<template>
    <div class="cart_item" :key="this_key" :class="{ _animate_in: is_new }" ref="cartItem">
      <div class="cart_item_inner">
        
        <component :is="is_hidden ? 'div' : 'a'" :href="computedUrl" class="cart_item_image_col">
          <img class="_self_loading_image" :class="{ _loaded: itemImageLoaded, _card_styling: this.product_type === 'Gift Cards' }" :src="utils.getSizedImageUrl(image || 'https://cdn.shopify.com/s/files/1/0219/7173/0504/files/fallback.jpg', '300x')" :style="{ background: utils.getSizedImageUrl(image || 'https://cdn.shopify.com/s/files/1/0219/7173/0504/files/fallback.jpg', '1x') }" @load="() => itemImageLoaded = true" :alt="`${ product_title } in Cart`">
        </component>

        <div class="cart_item_title_col">

          <div>
            <component :is="is_hidden ? 'div' : 'a'" :href="computedUrl">
              <div>
                {{ product_title }}
                <span v-if="shouldDisplayVariantTitle"> - {{ variant_title }}</span>
              </div>
              <div v-if="show_variant_info" v-for="(option, index) in options_with_values">
                <span v-if="!option.value.includes(option.name)">{{ option.name }} </span>{{ option.value }}
              </div>
            </component>
            <div class="cart_item_loyalty_points" v-if="loyaltyPointsMessage">
              {{ loyaltyPointsMessage }}
            </div>
          </div>

            <!--
            <button class="cart_item_move_to_wishlist" title="Move to Wishlist" aria-label="Move to Wishlist" @click.prevent="e => moveToWishlist(e)">Move to wishlist</button>
            -->

          <qty_adjuster :name="`updates[${ this_key }]`" :value="quantity" :min_prop="1" :max_prop="limit ? limit : 15" :onchange="update" v-if="!outOfStock"></qty_adjuster>
        </div>
        <div class="cart_item_price_col">
          <div class="cart_item_price_display">
            <div class="_text_strike" v-if="compare_at_price">{{ $options.filters.withCurrency($options.filters.money(compare_at_price)) }}</div>
            <div :class="{ cart_item_price_sale: compare_at_price, '_text_strike': discounted_price < price }">{{ itemPrice }}</div>
            <div v-if="discounted_price < price" class="cart_item_price_sale">{{ discountedPrice }}</div>
          </div>
          <button class="cart_item_delete" :aria-label="`Remove ${product_title} from cart`" @click.prevent="e => remove(e)" v-html="theme.icons.bin('100%')"></button>
        </div>
      </div>
      <cart_item_upsell v-if="upsell" :upsell="upsell" :originator="this_key" />
    </div>
</template>


<script>
  export default {
    name: 'cart_item',
    props: ['this_key', 'product_title','variant_title', 'product_type', 'adjustedPoints', 'is_new', 'url', 'image', 'show_variant_info', 'options_with_values', 'quantity', 'compare_at_price', 'price', 'discounted_price', 'upsell', 'limit', 'is_hidden', 'product_id', 'variant_id' ],
    data () {
      return {
        itemImageLoaded: false,
      }
    },
    computed: {
      itemPrice: function() {
        const { price, quantity } = this;

        if (!quantity) {
          return 'Out of stock';
        }

        const { formatMoney, withCurrency } = this.$options.filters;
        return price > 0 ? withCurrency(formatMoney(price)) : 'FREE';
      },
      discountedPrice: function() {
        const { discounted_price } = this;
        const { formatMoney, withCurrency } = this.$options.filters;
        return discounted_price > 0 ? withCurrency(formatMoney(discounted_price)) : 'FREE';
      },
      loyaltyPointsMessage: function() {
        const { adjustedPoints } = this;

        if (!(adjustedPoints && adjustedPoints !== '')) {
          return false;
        }

        try {
          const translation = theme?.translations?.loyalty?.cart_item?.[theme.customer ? 'logged_in_points_message' : 'logged_out_points_message'];
          return translation.replace('{{ points }}', adjustedPoints);
        } catch(err) {
          console.warn(err);
        }
        return false;
      },
      outOfStock: function() {
        const { quantity } = this;
        return !quantity;
      },

       shouldDisplayVariantTitle() {
        if (this.product_type !== 'Gift Cards' || !this.variant_title) {
          return false;
        }
        const match = this.variant_title.match(/([\d,.]+)/);
        if (!match) {
          return false;
        }

        const denominationPriceInCents = parseFloat(match[1].replace(',', '')) * 100;
        const shouldDisplay = denominationPriceInCents !== this.price;
        return shouldDisplay;
      },

       computedUrl() {
       if (this.product_type === "Gift Cards" && this.product_title !== "Gift Card")  {
        return `/products/gift-card?product_id=${this.product_id}&variant_id=${this.variant_id}`;
      }
      return this.url;
    },
    
    },
    methods: {
      update: async function(quantity, errorCallback) {
        const result = await window.cartUtils.updateItem(this.this_key, quantity);
        console.log(result);
        // TO DO: Change to result.error
        if (result === false) {
          errorCallback();
        }
      },
      remove: function(e) {
        const { cartItem } = this.$refs;
        const root = document.documentElement;
        root.style.setProperty('--cart_fill_space', `${ cartItem.clientHeight }px`);
        cartItem.classList.add('_animate_out');
        window.cartUtils.removeItem(this.this_key);
      },
      moveToWishlist: function(e) {
        console.log(this.product_title);
        const { addToWishlist } = window.wishlistUtils;
        addToWishlist();
        this.remove();
      },
    },
  }
</script>